import moment from 'moment'
import json2csv from 'json2csv'
import download from 'downloadjs'
import { saveAs } from 'file-saver'

export default {
  name: 'csvHelper',
  mime: 'application/csv',

  export: function (jsonData, fields, fieldNames, fileName) {
    const data = json2csv({ data: jsonData, fields, fieldNames, excelStrings: true, withBOM: true })
    let blob = this.base64ToBlob(data, this.mime)
    const csvFileName = `${fileName} - ${moment().format('MM/DD/YYYY h:mm:ss A')}.csv`
    download(blob, csvFileName, this.mime)
  },

  base64ToBlob: function (data, mime) {
    let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
    let bstr = atob(base64)
    let n = bstr.length
    let u8arr = new Uint8ClampedArray(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  },

  exportFromServerData: function (csvData, fileName) {
    const csvFileName = `${fileName} - ${moment().format('MM/DD/YYYY h:mm:ss A')}.csv`
    var csv = csvData
    var blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8'})
    saveAs(blob, csvFileName)
  }
}



// WEBPACK FOOTER //
// ./src/utils/csv-helper.js